import actionCreatorFactory from "typescript-fsa";
import { SystemListResponse } from "../../core/api/requests/system/list/types";
import { CommonAsyncType } from "../../core/types";

const actionCreator = actionCreatorFactory("@@System");

export const systemActions = {
  getSystemList: actionCreator.async<CommonAsyncType, SystemListResponse>("GET_SYSTEMS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
